import { createFeatureSelector, createSelector } from '@ngrx/store';
import { HttpExtenstionsModel, QueryResultsModel } from '../../_base/crud';
import { WorkOSsState } from '../_reducers/workOS.reducers';
import { each } from 'lodash-es';
import { WorkOS } from '../_models/workOS.model';

export const selectWorkOSsState = createFeatureSelector<WorkOSsState>('workOSs');

export const selectWorkOSById = (workOSId: number) =>
  createSelector(selectWorkOSsState, (workOSsState) => workOSsState.entities[workOSId]);

export const selectWorkOSsPageLoading = createSelector(selectWorkOSsState, (workOSsState) => {
  return workOSsState.listLoading;
});

export const selectWorkOSsActionLoading = createSelector(
  selectWorkOSsState,
  (workOSsState) => workOSsState.actionsloading,
);

export const selectLastCreatedWorkOSId = createSelector(
  selectWorkOSsState,
  (workOSsState) => workOSsState.lastCreatedWorkOSId,
);

export const selectWorkOSsPageLastQuery = createSelector(
  selectWorkOSsState,
  (workOSsState) => workOSsState.lastQuery,
);
export const selectWorkOSError = createSelector(
  selectWorkOSsState,
  (workOSsState) => workOSsState.error,
);
export const selectWorkOSLatestSuccessfullAction = createSelector(
  selectWorkOSsState,
  (workOSsState) => workOSsState.latestSuccessfullAction,
);
export const selectWorkOSsInStore = createSelector(selectWorkOSsState, (workOSsState) => {
  const items: WorkOS[] = [];
  each(workOSsState.entities, (element) => {
    items.push(element);
  });
  const httpExtension = new HttpExtenstionsModel();
  const result: WorkOS[] = httpExtension.sortArray(
    items,
    workOSsState.lastQuery.sortField,
    workOSsState.lastQuery.sortOrder,
  );
  return new QueryResultsModel(result, workOSsState.totalCount);
});

export const selectWorkOSsShowInitWaitingMessage = createSelector(
  selectWorkOSsState,
  (workOSsState) => workOSsState.showInitWaitingMessage,
);

export const selectHasWorkOSsInStore = createSelector(selectWorkOSsState, (queryResult) => {
  if (!queryResult.totalCount) {
    return false;
  }

  return true;
});
